import { render, staticRenderFns } from "./CulturalListYjjM.vue?vue&type=template&id=c3b280a2&scoped=true&"
import script from "./CulturalListYjjM.vue?vue&type=script&lang=js&"
export * from "./CulturalListYjjM.vue?vue&type=script&lang=js&"
import style0 from "./CulturalListYjjM.vue?vue&type=style&index=0&id=c3b280a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b280a2",
  null
  
)

export default component.exports